/** 供应商协同应用 code（与 etao_menu 顶级菜单一致） */
export const SRM_APP_CODE = 'srm'

/**
 * 按菜单 code 的门户展示元数据。
 * kind: main=主流程(S) / aux=辅助退料(A)
 * 未出现在此表中的菜单走普通样式。
 */
export const SRM_MENU_PORTAL_META = {
    'srm-purchase-order-list': {
        step: 'S1',
        kind: 'main',
        desc: '物料注册，送货前第一步'
    },
    'srm-material-pack': {
        step: 'S2',
        kind: 'main',
        desc: '执行最小小包装/外箱打包'
    },
    'srm-material-pack-adjust': {
        step: 'A1',
        kind: 'aux',
        desc: '包装异常时调整关联关系'
    },
    'srm-material-sn-list': {
        step: 'A2',
        kind: 'aux',
        desc: '查看 RID 与包装关联详情'
    },
    'srm-material-delivery': {
        step: 'S3',
        kind: 'main',
        desc: '扫描包装码或是小包装 RID 送货'
    },
    'srm-delivery-order': {
        step: 'S4',
        kind: 'main',
        desc: '审核送货单并打印送货单'
    },
    'srm-delivery-proof-history': {
        step: 'A5',
        kind: 'aux',
        desc: '证明材料有效期卡控与履历查询'
    },
    'srm-delivery-purchase-audit': {
        step: 'A6',
        kind: 'aux',
        desc: '送货单采购审核工作台'
    },
    'returned-order': {
        step: 'A3',
        kind: 'aux',
        desc: 'IQC/入库后不良退料执行'
    },
    'returned-order-list': {
        step: 'A4',
        kind: 'aux',
        desc: '供应商查看退货物料明细'
    }
}

export const SRM_PORTAL_LEGEND = [
    { kind: 'main', label: '主流程' },
    { kind: 'aux', label: '辅助/退料' }
]

export const SRM_PORTAL_FLOW = 'S1 采购订单 → S2 物料打包 → S3 物料送货 → S4 送货单管理'

export const SRM_PORTAL_HINT = 'S 为标准送货主流程，需按序执行；A 为辅助、查询、异常、退料相关，按需使用'

/**
 * 按菜单 code 取门户元数据
 *
 * @param {string} code 菜单 code
 * @returns {{ step: string, kind: 'main'|'aux', desc: string, tag?: string }|null}
 */
export function getSrmPortalMeta (code) {
    if (!code) {
        return null
    }
    return SRM_MENU_PORTAL_META[code] || null
}



// WEBPACK FOOTER //
// ./src/components/index/data/srmMenuPortal.js